<template>
    <b-form-group>
        <v-select
            v-model="projectValue"
            class="bg-white"
            :options="optgroups"
            :clearable="false"
        >
        </v-select>
    </b-form-group>
</template>

<script>
import ability from '@/libs/acl/ability'
import vSelect from 'vue-select'
import { computed, getCurrentInstance, ref, toRefs, watch } from '@vue/composition-api'
export default {
    components: {
        vSelect
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type: [Object, String]
        },
        plugin: {
            type: String
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const { value, plugin } = toRefs(props)
        const canPlugin = computed(() => ability.can('READ', plugin.value))
        const userRights = computed(() => store.getters.userRights)
        const projects = computed(() => canPlugin ? userRights.value.find(item => item.serviceName === plugin.value).projects : [])
        const createPluginProjectOption = item => ({ label: `${item.projectName} - ${item.usageAccountId}`, value: item })
        const optgroups = computed(() => projects.value.map(createPluginProjectOption))
        const projectValue = ref(value.value.projectIdx ? optgroups.value.find(opt => opt.value.projectIdx === value.value.projectIdx) : optgroups.value[0])
        watch(projectValue, (value, oldValue) => {
            const newValue = (value && value.value) || {}
            context.emit('change', newValue)
        }, {
            immediate: true,
            deep: true
        })
        return {
            optgroups,
            projectValue
        }
    }
}
</script>

<style>

</style>
